
import state from './zviz2/zviz/state';
import {LifeCycle} from './zviz2/zviz/cycle';



export let formatNumber = function(value, type='english', decimals=false){

    value = parseFloat(value);
    if(isNaN(value)){
        return '-';
    }

    let dec = '.';
    let th = ',';
    let bil = 'billion';
    let mil = 'million';
    if(type == 'dutch'){
        dec = ',';
        th = '.';
        bil = 'miljard';
        mil = 'miljoen';
    }

    if(value >= 100000000000){
        value = Math.round(value/1000000000) + ' ' + bil;
    }else if(value >= 10000000000){
        value = (value/1000000000).toFixed(decimals || 1) + ' ' + bil;
    }else if(value >= 1000000000){
        value = (value/1000000000).toFixed(decimals || 2) + ' ' + bil;
    }else if(value >= 100000000){
        value = Math.round(value/1000000) + ' ' + mil;
    }else if(value >= 10000000){
        value = (value/1000000).toFixed(decimals || 1) + ' ' + mil;
    }else if(value >= 1000000){
        value = (value/1000000).toFixed(decimals || 2) + ' ' + mil;
    }else if(value >= 100){
        value = Math.round(value);
    }else if(value >= 10){
        value = (value).toFixed(decimals || 1);
    }else{
        value = (value).toFixed(decimals || 2);
    }

    var parts = value.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
    if(parts.length>1){
        let p = parts[1].split(' ');
        if(parseInt(p[0]) == 0){
            if(p.length>1){
                parts[0] += ' ' + p[1];
            }
            parts.splice(1);
        }else if( p[0].substring(1,2) == '0'){
            parts[0] += dec + p[0].substring(0,1) + (p.length>1? ' ' + p[1]: '');
            parts.splice(1);
        }
    }
    return parts.join(dec);

}

export let formatDate = function(value, compact=true){
    let months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 
            'August', 'September', 'October', 'November', 'December'];
    // transform format dd/mm/yyyy to yyyy-mm-dd
    if(value.indexOf('/') != -1){
        let p = value.split('/');
        if(p.length == 3){
            value = p[2] + '-' + p[1] + '-' + p[0];
        }
    }
    let d = new Date(value);
    if(compact){
        return d.getDate() + '/' + (d.getMonth() + 1) + '/' + d.getFullYear();
    }else{
        return months[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
    }
}

export let setCleanFilter = function(type, value){
    // todo: we probably want to keep year and project status filters unchanged
    let newFilter = {};
    let year = state.get('filter.year');
    if(year){
        newFilter['year'] = year;
    }
    // resetting the filter value in two steps so that the
    // hierarchy check in the filter model work correctly
    state.set('filter', newFilter); // first reset old values
    // then add new value.
    state.set('filter.'+type, value);
}

export let scrollY = function(){
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");

    return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
}

export let scrollX = function(){
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");

    return supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
}

export let scrollTo = function(element, duration=500, toTopOfPage=false, space=120){
    let box = element.getBoundingClientRect();

    let top = box.top - space;
    let bottom = box.bottom;
    let st = scrollY();

    let offset = 0;
    if(toTopOfPage){
        offset = top;
    }else if(top < 0){
        offset = top;
    }else if(bottom > window.innerHeight){
        offset = Math.min(top, bottom-window.innerHeight);
    }
    
    let callback = function(fact, start, offset, x){
        window.scrollTo(x, start + Math.round(fact*offset));
    }

    let c = new LifeCycle([window, callback, st, offset, scrollX()], duration, 'cubic');
    return c;
}